import {
  getPullEventSyncLogListApi,
  getPushEventSyncLogListApi,
  triggerManualSyncEventsFromSapApi,
} from 'src/api/eventSyncLogApi';
import {
  GET_PULL_EVENT_LOGS_LIST,
  GET_PUSH_EVENT_LOGS_LIST,
  TRIGGER_MANUAL_SYNC_EVENTS_FROM_SAP,
} from 'src/redux/Actions/Type';

export function getPullEventSyncLogs(
  tenantOrganisationId,
  tenantId,
  typeKeyId,
  pageNumber,
  searchQuery,
  tableSortFieldOrder,
  tableSortField,
  startDate,
  endDate,
  resolved,
) {
  return (dispatch) =>
    getPullEventSyncLogListApi(
      tenantOrganisationId,
      tenantId,
      typeKeyId,
      pageNumber,
      searchQuery,
      tableSortFieldOrder,
      tableSortField,
      startDate,
      endDate,
      resolved,
    ).then((data) => {
      dispatch({
        type: GET_PULL_EVENT_LOGS_LIST,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getPushEventSyncLogs(
  tenantOrganisationId,
  tenantId,
  typeKeyId,
  pageNumber,
  searchQuery,
  tableSortFieldOrder,
  tableSortField,
  startDate,
  endDate,
  resolved,
) {
  return (dispatch) =>
    getPushEventSyncLogListApi(
      tenantOrganisationId,
      tenantId,
      typeKeyId,
      pageNumber,
      searchQuery,
      tableSortFieldOrder,
      tableSortField,
      startDate,
      endDate,
      resolved,
    ).then((data) => {
      dispatch({
        type: GET_PUSH_EVENT_LOGS_LIST,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function triggerManualSyncEventsFromSap(
  tenantOrganisationId,
  tableNumbers,
) {
  return (dispatch) =>
    triggerManualSyncEventsFromSapApi(tenantOrganisationId, tableNumbers).then(
      (data) => {
        dispatch({
          type: TRIGGER_MANUAL_SYNC_EVENTS_FROM_SAP,
          payload: data,
        });
        return Promise.resolve(data);
      },
    );
}
